import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { GruppoRicerca } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import {
  useDeleteGruppoRicerca,
  useGruppoRicerca,
  useUpdateGruppoRicerca,
} from '../../hooks/gruppi-ricerca'
import GruppoForm from '../../components/GruppoForm'

export default function GruppoEdit() {
  const { id } = useParams()
  const { data: gruppo } = useGruppoRicerca(+id!)
  const deleteGruppo = useDeleteGruppoRicerca()
  const updateGruppo = useUpdateGruppoRicerca()
  const [modalRm, modalRmActions] = useModalTrigger<GruppoRicerca>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/gruppi-ricerca">Gruppi ricerca</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {gruppo!.nome}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(gruppo)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <GruppoForm
          gruppo={gruppo}
          save={(gruppo) =>
            updateGruppo.mutateAsync(gruppo).then(() =>
              toast.success('Gruppo ricerca alvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare l'utente {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteGruppo.isLoading}
            onClick={async () => {
              await deleteGruppo.mutateAsync(modalRm.value!.id)
              navigate('/gruppi-ricerca')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
